import { render, staticRenderFns } from "./detailProgramOfficer.vue?vue&type=template&id=23a2ef9d&scoped=true"
import script from "./detailProgramOfficer.vue?vue&type=script&lang=js"
export * from "./detailProgramOfficer.vue?vue&type=script&lang=js"
import style0 from "./detailProgramOfficer.vue?vue&type=style&index=0&id=23a2ef9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a2ef9d",
  null
  
)

export default component.exports